import { useCallback, useEffect, useState } from "react";
import { Users } from "lucide-react";
import PageHeader from "../components/PageHeader";
import StudentTable from "../components/StudentTable";
import { listNewStudents, updateNewStudent, deleteNewStudent } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

const columns = [
  { key: "name", header: "اسم الطالب" },
  { key: "national_id", header: "رقم الهوية" },
  { key: "phone", header: "رقم الجوال" },
  { key: "guardian_phone", header: "جوال ولي الأمر" },
  { key: "stage", header: "المرحلة" },
  { key: "grade", header: "الصف" },
  { key: "section", header: "الفصل" },
  { key: "academic_year", header: "العام الدراسي" },
  { key: "registration_date", header: "تاريخ التسجيل" },
  { key: "enrollment_status", header: "الحالة" },
];

export default function NewStudentsList() {
  const { currentStage } = useAuth();
  const [rows, setRows] = useState([]);
  const reload = useCallback(async () => {
    const params = currentStage && currentStage !== "all" ? { stage: currentStage } : {};
    setRows(await listNewStudents(params));
  }, [currentStage]);
  useEffect(() => { reload(); }, [reload]);
  return (
    <div>
      <PageHeader title="عرض الطلاب المستجدين" subtitle="بحث وتصفية وتعديل سجلات الطلاب الجدد" icon={Users} />
      <StudentTable
        title="تقرير الطلاب المستجدين"
        rows={rows} columns={columns}
        dateKey="registration_date" dateLabel="تاريخ التسجيل"
        apiUpdate={updateNewStudent} apiDelete={deleteNewStudent}
        reload={reload} testidPrefix="new-list" accent="teal"
        showGuardian
        showEnrollmentStatus
      />
    </div>
  );
}
